import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFilter = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M3 5.591c0-.81.656-1.466 1.466-1.466h15.068a1.467 1.467 0 0 1 1.136 2.39l-5.858 7.19v5.034c0 .626-.51 1.136-1.135 1.136-.257 0-.506-.088-.707-.278l-3.252-2.549a1.41 1.41 0 0 1-.53-1.1v-2.243L3.33 6.515A1.46 1.46 0 0 1 3 5.592m1.932.221 5.753 7.06c.123.151.19.34.19.534v2.405l2.25 1.786v-4.19c0-.194.067-.384.19-.535l5.751-7.06z"
    }));
export default SvgFilter;
